<div class="ticket">
  <div class="ticket__card">
    <div
      class="ticket__card-header"
      [class.bg-gray-light]="ticket.ticket_status.id === 1"
      [class.bg-blue-light]="ticket.ticket_status.id === 2 || ticket.ticket_status.id === 3 || ticket.ticket_status.id === 7"
      [class.bg-pink-light]="ticket.ticket_status.id === 4 || ticket.ticket_status.id === 5 || ticket.ticket_status.id === 9"
      [class.bg-green-light]="ticket.ticket_status.id === 6 || ticket.ticket_status.id === 8"
    >
      <div class="header__communicator_and_extra">
        <div class="grid">
          <div class="grid__box grid__box--size-6">
            <div
              class="color-gray-dark font-weight-bold ticket__time"
              [title]="'Время: ' + (ticket.hd_schedule_intbegin | dateFormat: 'HH:mm') + ' - ' + (ticket.hd_schedule_intend | dateFormat: 'HH:mm')"
            >
              {{ ticket.hd_schedule_intbegin | dateFormat: 'HH:mm' }} - {{ ticket.hd_schedule_intend | dateFormat: 'HH:mm' }}
            </div>
          </div>
          <div class="grid__box grid__box--size-6">
            <ng-container *ngIf="ticket && ticket.ticket_type.id !== 4">
              <app-tickets-extra-new [ticket]="ticket"></app-tickets-extra-new>
            </ng-container>
          </div>
        </div>
        <ng-container *ngIf="ticket && ticket.ticket_type.id === 4 && isCompact">
          <app-ticket-communicator-info-new [ticket]="ticket"></app-ticket-communicator-info-new>
        </ng-container>
      </div>
      <!-- Блок ВК/HD статусов - показываем только если не экстра-компактный -->
      <div class="mt-8" *ngIf="shouldShowVkHdStatuses">
        <div class="status-row">
          <div class="status-item">
            <span class="font-weight-bold status-label">ВК:</span>
            <span
              class="text-italic status-text"
              [title]="ticket.ticket_status && ticket.ticket_status.name"
              [class]="'color-' + Enums.ticketHighlightStatuses[ticket.ticket_status && ticket.ticket_status.id]"
            >
              {{ ticket.ticket_status && ticket.ticket_status.name }}
            </span>
          </div>
        </div>
        <div class="status-row">
          <div class="status-item">
            <span class="font-weight-bold status-label">HD:</span>
            <span class="text-italic status-text" [title]="ticket.hd_ticket_status && ticket.hd_ticket_status.name">
              {{ ticket.hd_ticket_status && ticket.hd_ticket_status.name }}
            </span>
          </div>
          <!-- Статус линии - показываем всегда, кроме типа 4 -->
          <div class="line-status" *ngIf="ticket.ticket_type.id !== 4 && ticket.hd_line_status_info != null">
            <span class="font-size-12 line-height-16 cursor-pointer line-status-refresh" (click)="refreshLineStatus($event)">
              <ng-container *ngIf="!isRefreshingLineStatus">
                <span class="color-red-dark" *ngIf="ticket.hd_line_status_info === 0">off</span>
                <span class="color-green-dark" *ngIf="ticket.hd_line_status_info === 1">on</span>
              </ng-container>
              <span class="line-status-refresh__spinner" *ngIf="isRefreshingLineStatus"></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="ticket__card-content">
      <div class="grid">
        <div class="grid__box">
          <a
            class="link"
            [routerLink]="['/', TICKETS_PATHS.ticketLink, ticket.id]"
            [style.max-width]="ticketNumberMaxWidth"
            [style.overflow]="isCompact || isExtraCompact ? 'hidden' : 'visible'"
            [style.text-overflow]="isCompact || isExtraCompact ? 'ellipsis' : 'clip'"
            [style.white-space]="isCompact || isExtraCompact ? 'nowrap' : 'normal'"
            [style.display]="isCompact || isExtraCompact ? 'inline-block' : 'inline'"
            [title]="ticket.hd_ticket_number"
          >
            {{ ticket.hd_ticket_number }}
          </a>
        </div>
      </div>
      <div class="grid grid--gap-8">
        <div class="grid__box grid__box--size-min">
          <app-tickets-types-new [ticket]="ticket"></app-tickets-types-new>
        </div>
        <div class="grid__box grid__box--size-8">
          <div
            class="text-ellipsis"
            [title]="ticket.ticket_subtype"
            [style.width]="serviceTextMaxWidth"
            *ngIf="ticket.ticket_type && [3, 4, 5].indexOf(ticket.ticket_type.id) > -1"
          >
            {{ ticket.ticket_subtype }}
          </div>
          <!-- Если сервисов нет, ничего не отображаем -->
          <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id !== 1">
            <div [style.max-width]="serviceTextMaxWidth" [style.overflow]="'hidden'" [style.text-overflow]="'ellipsis'" [style.white-space]="'nowrap'">
              <app-tickets-services-new [services]="ticket.services" [ticket]="ticket" [iconsOnly]="true" [forceMoreOnly]="isCompact || isExtraCompact"></app-tickets-services-new>
            </div>
          </ng-container>
          <ng-container *ngIf="ticket.ticket_type.id === 1 && ticket.hd_ticket_type.id === 1 && ticket.extra_flags.moveaddr">
            <div [style.max-width]="serviceTextMaxWidth" [style.overflow]="'hidden'" [style.text-overflow]="'ellipsis'" [style.white-space]="'nowrap'">
              <app-tickets-services-new [services]="ticket.services" [ticket]="ticket" [iconsOnly]="true" [forceMoreOnly]="isCompact || isExtraCompact"></app-tickets-services-new>
            </div>
          </ng-container>
          <ng-container *ngIf="ticket.ticket_type.id === 2">
            <div [style.max-width]="serviceTextMaxWidth" [style.overflow]="'hidden'" [style.text-overflow]="'ellipsis'" [style.white-space]="'nowrap'">
              <app-tickets-services-new [services]="ticket.services" [ticket]="ticket" [iconsOnly]="true" [forceMoreOnly]="isCompact || isExtraCompact"></app-tickets-services-new>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- TVE/WiFi - показываем только если не компактный -->
      <ng-container
        *ngIf="shouldShowTveWifi && ticket.services && (ticket.services.tve_count || ticket.services.wifi_count || ticket.services.tve_services || ticket.services.wifi_services)"
      >
        <app-tickets-tve-wifi [services]="ticket.services" [ticket]="ticket"></app-tickets-tve-wifi>
      </ng-container>
      <div class="mt-8">
        <div style="flex-direction: column" class="grid">
          <div class="grid__box">
            <div class="font-weight-bold text-ellipsis-3 cur-help" [style.width]="districtMaxWidth" [title]="ticket.district.district_name">
              {{ ticket.district.district_name }}
            </div>
          </div>
        </div>
      </div>
      <!-- CTN абонента - показываем только если не экстра-компактный -->
      <div class="mt-8" *ngIf="shouldShowCtn && ticket.extra_flags && ticket.extra_flags.ctn">
        <div class="grid">
          <div class="grid__box grid__box--size-min">
            <span class="font-weight-bold">CTN</span>
          </div>
          <div class="grid__box grid__box--pull-right ta-right">
            {{ ticket.extra_flags.ctn }}
          </div>
        </div>
      </div>
      <!-- Адрес - показываем только если не экстра-компактный -->
      <div class="mt-8 pos-r" *ngIf="shouldShowAddress">
        <div class="card-content__address cur-help" [style.max-width]="addressMaxWidth" [title]="ticket.hd_address">{{ ticket.hd_address }}</div>
      </div>
      <div class="mt-8">
        <div class="grid">
          <!-- ГП проверка - показываем только если не компактный -->
          <div style="display: none" class="grid__box grid__box--size-6 no-wrap" *ngIf="shouldShowGpCheck">
            <app-ticket-global-problem-check-new [ticket]="ticket"></app-ticket-global-problem-check-new>
          </div>
          <!-- Бригада и назначение -->
          <div class="grid__box" [class.grid__box--size-12]="!shouldShowGpCheck" [class.grid__box--size-6]="shouldShowGpCheck">
            <div class="text-ellipsis no-wrap" *ngIf="ticket.brigade" [title]="ticket.brigade.brigade_name" (click)="brigadeAssignCmp.openPopover()">
              <app-brigade-popover [brigade]="ticket.brigade" [enablePopover]="!brigadeAssignCmp.isCanAssignTicket"></app-brigade-popover>
            </div>
            <app-tickets-brigade-assign-new
              [ticket]="ticket"
              [filter]="filter"
              [ticketsCurrentFilter]="ticketsCurrentFilter"
              [brigadeAssign]="brigadeAssign"
              [ticketsMultipleAssign]="ticketsMultipleAssign"
              [index]="intervalIndex"
              #brigadeAssignCmp
            ></app-tickets-brigade-assign-new>
          </div>
        </div>
      </div>
    </div>
    <div class="ticket__card-assign">
      <div class="card-assign__wrapper" *ngIf="ticket.ticket_status.id !== 6 && ticket.ticket_status.id !== 8">
        <app-ticket-checker-new
          [ticket]="ticket"
          [ticketsMultipleAssign]="ticketsMultipleAssign"
          [ticketsCurrentFilter]="ticketsCurrentFilter"
          [isMatrix]="true"
        ></app-ticket-checker-new>
      </div>
    </div>
  </div>
</div>
